<template>
	<v-card>
		<v-card-title>
			<translate>Exclude Series</translate>
		</v-card-title>
		<v-card-text>
			<v-row>
				<v-col>
					<v-text-field
						v-model="search"
						append-inner-icon="$search"
						:label="$gettext('Search')"
						single-line
						variant="outlined"
						hide-details
						clearable
					/>
				</v-col>
				<v-col>
					<v-checkbox
						v-model="showExcluded"
						hide-details
						:label="$gettext('Excluded only')"
						:disabled="updatedExclusions.length !== 0"
					/>
				</v-col>
			</v-row>
			<v-row>
				<v-col>
					<model-backend-table
						ref="seriesTable"
						:endpoint="endpoint"
						:headers="tableHeaders"
						:filter="filter"
						:items-per-page-options="[ 5, 10, 15,]"
					>
						<template #item.excluded="{ item }">
							<v-checkbox-btn
								:model-value="item.excluded"
								color="primary"
								@input="update(item)"
							/>
						</template>
					</model-backend-table>
				</v-col>
			</v-row>
		</v-card-text>
		<v-card-actions>
			<v-btn
				color="primary"
				:disabled="updatedExclusions.length === 0"
				@click="save"
			>
				<translate>
					Save
				</translate>
			</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
import ModelBackendTable from './ModelBackendTable.vue';
import {
	axios,
} from '../../services/axios-service';
import {
	displayError, inform,
} from 'laravel-front-library';

export default {
	name: 'PricingParameterExclusions',
	components: {
		ModelBackendTable
	},

	data () {
		return {
			search: null,
			showExcluded: false,
			updatedExclusions: []
		};
	},

	computed: {
		endpoint () {
			return this.showExcluded ? '/bo/pricing/series/excluded' : '/bo/pricing/series';
		},

		/**
		 * @returns {Array} table headers
		 */
		tableHeaders () {
			return [
				{
					title: `${this.$gettext('Series')} ID`,
					value: 'id',
				},
				{
					title: `${this.$gettext('Brand')} ID`,
					value: 'brandId',
				},
				{
					title: this.$gettext('Brand'),
					value: 'brand',
					sortable: false,
				},
				{
					title: this.$gettext('Series'),
					value: 'name',
				},
				{
					title: this.$gettext('Excluded'),
					value: 'excluded',
					sortable: false,
				},
			];
		},

		filter () {
			return this.search ? {
				'search': this.search
			} : {
			};
		}
	},

	mounted () {
		// Keep table up to date with local changes
		this.$watch(
			() => {
				return this.$refs.seriesTable.loading;
			},
			(val) => {
				if (!val) {
					this.$refs.seriesTable.items.filter((series) => this.updatedExclusions.some(
						(update) => (series.id === update.id)
					)).forEach(function (series) {
						series.excluded = !series.excluded;
					});
				}
			}
		);
	},

	methods: {
		/**
		 * Update series exclusion and add or removing from the list of locally changed series
		 *
		 * @param {object} series
		 * @returns {void}
		 */
		update (series) {
			if (this.updatedExclusions.some((updatedExclusion) => updatedExclusion.id === series.id)) {
				this.updatedExclusions = this.updatedExclusions.filter((updatedExclusion) => {
					return updatedExclusion.id !== series.id;
				});
			} else {
				this.updatedExclusions.push(series);
			}

			series.excluded = !series.excluded;
		},

		/**
		 * Save changes to series exclusions
		 *
		 * @returns {void}
		 */
		save () {
			axios.put('/bo/pricing/series',
				this.updatedExclusions
			).then(() => {
				inform(this.$gettext('Exclusions updated'));
				this.updatedExclusions = [];
				this.$refs.seriesTable.index();
			}).catch((e) => {
				displayError(this.$gettext('Unfortunately an error occurred, please try again later.'));
				window.captureException(e);
			});
		},
	}
};
</script>
